import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageLogFrontService } from '@services/message-log/message-log.service';

@Component({
    selector: 'app-push-devices-dialog',
    templateUrl: './push-devices-dialog.component.html',
    styleUrls: ['./push-devices-dialog.component.scss'],
})
export class PushDevicesDialogComponent implements OnInit {
    loading = true;
    customTitle = '';

    devices: any[] = [];
    filteredDevices: any[] = [];

    // filtros
    filter = '';
    platformFilter: '' | 'ios' | 'android' = '';
    pushOnlyFilter = false;

    displayedColumns = ['nombre', 'email', 'platform', 'token'];

    constructor(
        private logService: MessageLogFrontService,
        private dialogRef: MatDialogRef<PushDevicesDialogComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    async ngOnInit() {
        if (this.data?.users) {
            this.loading = true;
            this.customTitle = this.data.title || '👥 Listado de Afiliados';
            this.devices = [...this.data.users];

            if (this.data.tipo === 'push') {
                this.pushOnlyFilter = true;
            } else if (this.data.tipo === 'ios') {
                this.platformFilter = 'ios';
            } else if (this.data.tipo === 'android') {
                this.platformFilter = 'android';
            }

            setTimeout(() => {
                this.applyFilter();
                this.loading = false;
            }, 250);
        } else {
            await this.loadAll();
        }
    }

    private async loadAll() {
        this.loading = true;

        try {
            const r: any = await this.logService.getDevicesList();

            console.log('📦 RAW DEVICES RESPONSE:', r);

            // 🔥 parse ultra defensivo
            const list =
                r?.response?.response?.response ??
                r?.response?.response ??
                r?.response ??
                [];

            console.log('📊 LIST FINAL:', list);

            this.devices = Array.isArray(list) ? list : [];
            this.applyFilter();
        } finally {
            this.loading = false;
        }
    }

    applyFilter() {
        const q = (this.filter || '').trim().toLowerCase();

        this.filteredDevices = this.devices.filter((d) => {
            const okPlatform =
                !this.platformFilter || (d.pushPlatform || '').toLowerCase() === this.platformFilter;

            const okPush = !this.pushOnlyFilter || !!d.pushToken;

            const okText =
                !q ||
                (d.nombrePersona || '').toLowerCase().includes(q) ||
                (d.apellidoPersona || '').toLowerCase().includes(q) ||
                (d.email || '').toLowerCase().includes(q);

            return okPlatform && okPush && okText;
        });
    }

    tokenPreview(token: string) {
        if (!token) return 'Sin token';
        return '****' + token.slice(-6);
    }

    close() {
        this.dialogRef.close();
    }
}
